import { Http } from '@angular/http';
import { Injectable, Optional, Host, SkipSelf } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { UtilityService } from './UtilityService';
import { Observable, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractControl, ControlContainer } from '@angular/forms';
import { AppInjector } from '../../controls/bnsights-library.module';
import { TextboxComponent } from '../../controls/TextBox/textbox.component';

@Injectable()
export class DataService
{
  // tslint:disable-next-line: deprecation
  constructor( private http: Http)
  { 
  }

   accessFormController(formControlName: string)
  {
    let controlContainer: any ;
    try {
       // tslint:disable-next-line: deprecation
       controlContainer = AppInjector.get(ControlContainer);
    } catch (error) {
      throw error;
    }

    if (controlContainer) {
          if (formControlName) {

            const control: AbstractControl = controlContainer.control.get(formControlName);
            console.log('control is :')
            console.log(control);
            control.setErrors({required: true});
          } else {
            console.warn('Missing FormControlName directive from host element of the component');
          }
        } 
        else {
          console.warn('Can\'t find parent FormGroup directive');
        }
  }

  // ====================================================

  ngGet(url: string, id?: number)
 {
    UtilityService.blockUI();
    let result;
    if (id == null) {
      result = this.http.get(url)
        .pipe(map(response => response.json()));
    } else {
      result = this.http.get(url + '/' + id)
        .pipe(map(response => response.json()), catchError(this.handleError));
    }
    // .catch(this.handleError);
    setTimeout(() => {
      UtilityService.endBlockUI();
    }, 1000);

    return result;
  }

  ngPost(url: string, resource: any)
   {
    UtilityService.blockUI();
    const result: any = this.http.post(url, resource)
      .pipe(map(response => response.json()), catchError(this.handleError));

    setTimeout(() => {
      UtilityService.endBlockUI();
    }, 1000);

    return result;
    // .catch(this.handleError);
  }

  ngPut(url: string, resource: any, id: number)
   {
    UtilityService.blockUI();
    const result = this.http.put(url + '/' + id, resource)
      .pipe(map(response => response.json()), catchError(this.handleError));
    setTimeout(() => {
      UtilityService.endBlockUI();
    }, 1000);

    return result;
    // .catch(this.handleError);
  }

  ngDelete(url: string, id) {

    UtilityService.blockUI();
    const result = this.http.delete(url + '/' + id)
      .pipe(map(response => response.json()), catchError(this.handleError));
    setTimeout(() => {
      UtilityService.endBlockUI();
    }, 1000);

    return result;
    // .catch(this.handleError);

  }

  handleError(error: HttpErrorResponse)
  {
    if (error.status === 400)
    {
      const errorBody = JSON.parse(error['_body']);
      console.log(errorBody.errors)
      if (errorBody.errors != undefined) {
        console.log(typeof( TextboxComponent.showErrorOfInputs))
      TextboxComponent.showErrorOfInputs(errorBody.errors)
      return throwError(errorBody);
      } else {
        UtilityService.notifyErrorMassage(error['_body']);
        return throwError(errorBody);
      }
    }
    if (error.status === 404) {
      // tslint:disable-next-line: deprecation
      return Observable.throw(error);
    }

    UtilityService.notifyErrorMassage();
    // tslint:disable-next-line: deprecation
    return Observable.throw(error);

  }
  // =================================================
}
